import { useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GENERIC_ERROR =
  "Something went wrong. Please try again or call us directly.";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  company: "",
  country: "",
  expo: "",
  size: "",
  budget: "",
  message: "",
  website: "", // honeypot
};

const parseErrorMessage = async (response) => {
  const data = await response.json().catch(() => ({}));
  const detail = data && data.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && e.msg) || "Invalid input").join(", ");
  }
  return `Request failed (${response.status})`;
};

const postQuote = async (form) => {
  const response = await fetch(`${API}/quote-request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(form),
  });
  if (!response.ok) {
    throw new Error(await parseErrorMessage(response));
  }
  return response.json();
};

export const useQuoteForm = () => {
  const [form, setForm] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await postQuote(form);
      setSubmitted(true);
      // GA4 conversion event
      if (typeof window.gtag === "function") {
        window.gtag("event", "generate_lead", {
          form_name: "quote_request",
          country: form.country || undefined,
          expo: form.expo || undefined,
          stand_size: form.size || undefined,
          value: 1,
          currency: "USD",
        });
      }
    } catch (err) {
      setError(err.message || GENERIC_ERROR);
    } finally {
      setSubmitting(false);
    }
  };

  return { form, submitted, submitting, error, onChange, onSubmit };
};
